module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.checkListAnswers.length > 0) ? _c('div', {
    staticClass: "form-section"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("체크리스트")]), _vm._v(" "), _c('ul', {
    staticClass: "check-list"
  }, [_c('li', [_c('div', {
    staticClass: "tit"
  }, [_vm._v("1. 현재 정부의 재정지원 직접일자리사업에 참여하고 있습니까?")]), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('label', {
    staticClass: "radio-item",
    attrs: {
      "for": "checkQ1Y"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: ((_vm.checkListAnswers[0] || {}).ANSWER),
      expression: "(checkListAnswers[0] || {}).ANSWER"
    }],
    staticClass: "sr-only job-history-questions",
    attrs: {
      "type": "radio",
      "id": "checkQ1Y",
      "data-seq": "1",
      "value": "Y",
      "disabled": _vm.isDisabled,
      "title": "checkQ1Y 선택"
    },
    domProps: {
      "checked": _vm._q((_vm.checkListAnswers[0] || {}).ANSWER, "Y")
    },
    on: {
      "change": function($event) {
        _vm.$set((_vm.checkListAnswers[0] || {}), "ANSWER", "Y")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n            예\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-item",
    attrs: {
      "for": "checkQ1N"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: ((_vm.checkListAnswers[0] || {}).ANSWER),
      expression: "(checkListAnswers[0] || {}).ANSWER"
    }],
    staticClass: "sr-only job-history-questions",
    attrs: {
      "type": "radio",
      "id": "checkQ1N",
      "data-seq": "1",
      "value": "N",
      "disabled": _vm.isDisabled,
      "title": "checkQ1N 선택"
    },
    domProps: {
      "checked": _vm._q((_vm.checkListAnswers[0] || {}).ANSWER, "N")
    },
    on: {
      "change": function($event) {
        _vm.$set((_vm.checkListAnswers[0] || {}), "ANSWER", "N")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n            아니요\n          ")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tit"
  }, [_vm._v("2. 현재 서울시 가치동행일자리 사업, 재단의 중장년 경력 인재 지원 사업에 참여하고 있습니까?")]), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('label', {
    staticClass: "radio-item",
    attrs: {
      "for": "checkQ2Y"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: ((_vm.checkListAnswers[1] || {}).ANSWER),
      expression: "(checkListAnswers[1] || {}).ANSWER"
    }],
    staticClass: "sr-only job-history-questions",
    attrs: {
      "type": "radio",
      "id": "checkQ2Y",
      "data-seq": "2",
      "value": "Y",
      "disabled": _vm.isDisabled,
      "title": "checkQ2Y 선택"
    },
    domProps: {
      "checked": _vm._q((_vm.checkListAnswers[1] || {}).ANSWER, "Y")
    },
    on: {
      "change": function($event) {
        _vm.$set((_vm.checkListAnswers[1] || {}), "ANSWER", "Y")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n            예\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-item",
    attrs: {
      "for": "checkQ2N"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: ((_vm.checkListAnswers[1] || {}).ANSWER),
      expression: "(checkListAnswers[1] || {}).ANSWER"
    }],
    staticClass: "sr-only job-history-questions",
    attrs: {
      "type": "radio",
      "id": "checkQ2N",
      "data-seq": "2",
      "value": "N",
      "disabled": _vm.isDisabled,
      "title": "checkQ2N 선택"
    },
    domProps: {
      "checked": _vm._q((_vm.checkListAnswers[1] || {}).ANSWER, "N")
    },
    on: {
      "change": function($event) {
        _vm.$set((_vm.checkListAnswers[1] || {}), "ANSWER", "N")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n            아니요\n          ")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tit"
  }, [_vm._v("3. 신청 예정인 활동처(기업,기관)에서 활동 또는 근무한 경험이 있습니까?")]), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('label', {
    staticClass: "radio-item",
    attrs: {
      "for": "checkQ3Y"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: ((_vm.checkListAnswers[2] || {}).ANSWER),
      expression: "(checkListAnswers[2] || {}).ANSWER"
    }],
    staticClass: "sr-only job-history-questions",
    attrs: {
      "type": "radio",
      "id": "checkQ3Y",
      "data-seq": "3",
      "value": "Y",
      "disabled": _vm.isDisabled,
      "title": "checkQ3Y 선택"
    },
    domProps: {
      "checked": _vm._q((_vm.checkListAnswers[2] || {}).ANSWER, "Y")
    },
    on: {
      "change": function($event) {
        _vm.$set((_vm.checkListAnswers[2] || {}), "ANSWER", "Y")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n            예\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-item",
    attrs: {
      "for": "checkQ3N"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: ((_vm.checkListAnswers[2] || {}).ANSWER),
      expression: "(checkListAnswers[2] || {}).ANSWER"
    }],
    staticClass: "sr-only job-history-questions",
    attrs: {
      "type": "radio",
      "id": "checkQ3N",
      "data-seq": "3",
      "value": "N",
      "disabled": _vm.isDisabled,
      "title": "checkQ3N 선택"
    },
    domProps: {
      "checked": _vm._q((_vm.checkListAnswers[2] || {}).ANSWER, "N")
    },
    on: {
      "change": function($event) {
        _vm.$set((_vm.checkListAnswers[2] || {}), "ANSWER", "N")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n            아니요\n          ")])])]), _vm._v(" "), _c('li', {
    staticClass: "sub-list"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("(3)에서 \"예\" 라고 지원하는 경우 활동처명과 직책을 기재하여 주시기 바랍니다.")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('span', {
    staticClass: "th-name"
  }, [_vm._v("활동처명")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: ((_vm.checkListAnswers[2] || {}).DTL_ANSWER_1),
      expression: "(checkListAnswers[2] || {}).DTL_ANSWER_1"
    }],
    staticClass: "short-input",
    attrs: {
      "type": "text",
      "placeholder": "활동처명",
      "title": "활동처명",
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": ((_vm.checkListAnswers[2] || {}).DTL_ANSWER_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set((_vm.checkListAnswers[2] || {}), "DTL_ANSWER_1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "th-name"
  }, [_vm._v("근무시 직책")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: ((_vm.checkListAnswers[2] || {}).DTL_ANSWER_2),
      expression: "(checkListAnswers[2] || {}).DTL_ANSWER_2"
    }],
    staticClass: "short-input",
    attrs: {
      "type": "text",
      "placeholder": "근무시 직책",
      "title": "근무시 직책",
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": ((_vm.checkListAnswers[2] || {}).DTL_ANSWER_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set((_vm.checkListAnswers[2] || {}), "DTL_ANSWER_2", $event.target.value)
      }
    }
  })])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-058a3c38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/APP/InSpecificFields.vue
// module id = 1276
// module chunks = 6